export const SortDirection = {
  Ascending: 0,
  Descending: 1,
  None: 2
};